import { connect } from 'react-redux'
import * as action from '../../state/image/action'
import * as selector from '../../state/image/selector'
import VersionedImageList from './VersionedImageList'
import { selectCanSeeImages, selectIsCustomerServiceTeamLead } from '../../../security/state/auth/selector'


const mapStateToProps = (state, props) => {
    return {
        canSeeImages: selectCanSeeImages(state),
        imageVersionList: selector.selectOrderedImageVersionList(state),
        showImages: selector.selectShowImages(state),
        showDeleteImage: selectIsCustomerServiceTeamLead(state),
    }
}

const mapDispatchToProps = {
    findImageVersion: action.findImageVersion,
    uploadCustomerImage: action.uploadCustomerImage,
    rotateCustomerImage: action.rotateCustomerImage,
    toggleImageView: action.toggleImageView,
    setImageTypeMetaData: action.setImageTypeMetaData,
    deleteCustomerImage: action.deleteCustomerImage
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionedImageList)



// WEBPACK FOOTER //
// ./src/modules/customer/component/image/VersionedImageListContainer.js